import React, { useRef, useEffect, useState } from "react";
import "../RffitLaboratoriesFrom/RffitLaboratoriesFrom.css";
import { useLocation } from "react-router-dom";
import axios from "axios";
import Rff1 from "../../images/rff1.png";
import Rff2 from "../../images/rff2.png";
import Rff3 from "../../images/rff3.png";
import Rff4 from "../../images/rff4.png";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const RffitLaboratoriesForm = () => {
  const editableRef = useRef(null);
  const location = useLocation();
  const Relocation_Id = location.state?.Relocation_Id; // Get Relocation_Id from route state
  const baseAPI = process.env.REACT_APP_API_URL;

  const downloadAsPDF = () => {
    const input = document.getElementById("rff-pdf-content");

    html2canvas(input, {
      scale: 3, // Increase the scale for higher resolution
      useCORS: true, // Ensure cross-origin images are rendered
      backgroundColor: "#ffffff", // Explicitly set background to white to avoid transparency issues
    })
      .then((canvas) => {
        const imgData = canvas.toDataURL("image/jpeg", 1.0); // Use 1.0 for best quality
        const pdf = new jsPDF("p", "mm", "a4");
        const pdfWidth = 210;
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

        pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHeight);
        pdf.save("Estimate.pdf");
      })
      .catch((error) => {
        console.error("Error generating PDF:", error);
      });
  };

  useEffect(() => {
    const fetchRows = async () => {
      try {
        const storedToken = JSON.parse(localStorage.getItem("token"));
        if (!Relocation_Id) {
          console.error("Relocation_ID is not defined");
          alert("Relocation_ID is not available. Please check the data.");
          return;
        }

        const response = await axios.get(
          `${baseAPI}userget/GetRffitLaboratoriForm?relocation_id=${Relocation_Id}`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        );

        if (response.data.status === "True" && response.data.data?.RffitLaboratoriForm?.length > 0) {
          const formData = response.data.data.RffitLaboratoriForm[0]; // Correctly accessing the first object
        
          setRffiFormData((prevData) => ({
            ...prevData,
            ...formData, // Use formData, NOT response.data.data[0]
          }));
      
        } else {
          console.warn("No data found for this Relocation_Id");
        }
      } catch (error) {
        console.error("Error fetching rows data:", error);
      }
    };

    fetchRows();
  }, [Relocation_Id, baseAPI]);

  const [isEditing, setIsEditing] = useState(false);

  const [rffiFormData, setRffiFormData] = useState({
    relocation_id: Relocation_Id,
    Owner_Mail_Phone: "",
    RFFI_MIA: "",
    RFFI_Female: "",
    RFFI_SHIH: "",
    RFFI_Years_Months: "",
    RFFI_Date_Time: "",
    RFFI_Tri_Colour: "",
    RFFI_Microchip: "",
    RFFI_Vaccination: "",
    RFFI_Date_Collected: "",
    RFFI_Date_Submitted: "",
    RFFI_Vaccination_Enclosed: "",
    RFFI_Name_Clinician: "",
  });

  

  // data send
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      const response = await axios.post(
        `${baseAPI}UserPost/RffitLaboratoriForm`,
        rffiFormData,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
            "Content-Type": "application/json", // JSON content type for a regular API call
          },
        }
      );
      setRffiFormData({
        Owner_Mail_Phone: "",
        RFFI_MIA: "",
        RFFI_Female: "",
        RFFI_SHIH: "",
        RFFI_Years_Months: "",
        RFFI_Date_Time: "",
        RFFI_Tri_Colour: "",
        RFFI_Microchip: "",
        RFFI_Vaccination: "",
        RFFI_Date_Collected: "",
        RFFI_Date_Submitted: "",
        RFFI_Vaccination_Enclosed: "",
        RFFI_Name_Clinician: "",
        created_By: "",
      });
      if (response.data.status === "True") {
        alert("Practice information submitted successfully!");
      } else {
        alert(`Submission failed: ${response.data.message || "Unknown error"}`);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert(
        `An error occurred while submitting the form. Please try again.\nError: ${
          error.response?.data?.message || error.message
        }`
      );
    }
  };
  const toggleEdit = () => {
    setIsEditing(!isEditing);
  };

  return (
    <div>
      <div className="a4-form1" id="rff-pdf-content">
        <div style={{ padding: "4px 0 0 5px", border: "2px solid black" }}>
          <div className="row">
            <div className="col-4">
              <div>
                <img src={Rff1} alt="Rff1 Logo" />
              </div>
            </div>
            <div className="col-4">
              <img src={Rff3} alt="Rff3 Logo" />
            </div>
            <div className="col-4" style={{ textAlign: "center" }}>
              <img src={Rff2} alt="Rff2 Logo" />
            </div>

            <div className="row header-text-rff">
              <div style={{height: '0px'}}>
                <img
                  src={Rff4}
                  alt="Rff4 Logo"
                  style={{
                    position: "relative",
                    top: "2rem",
                    left: "-17.5rem",
                    width: "10rem",
                  }}
                />
              </div>

              <div style={{ paddingBottom: "22px" }}>
                <h2
                  style={{
                    textAlign: "end",
                    height: "auto",
                    fontSize: "15.2px",
                  }}
                >
                  KARNATAKA VETERINARY, ANIMAL AND FISHERIES SCIENCES
                  UNIVERSITY, BIDAR
                </h2>
                <h3 style={{ fontSize: "15.2px", marginLeft: "6rem" }}>
                  KVAFSU-CVA RABIES DIAGNOSTIC LABORATORY
                </h3>
                <h3 style={{ fontSize: "15.2px", marginLeft: "6rem" }}>
                  DEPARTMENT OF VETERINARY MICROBIOLOGY
                </h3>
                <h3 style={{ fontSize: "15.2px", marginLeft: "6rem" }}>
                  VETERINARY COLLEGE, HEBBAL, BENGALURU – 560 024
                </h3>
              </div>
            </div>
          </div>

          {/* Table Stretcher  */}
          <div style={rffFormat1}>
            <div style={rffFormat2}>
              <span style={rffFormat3}>
                FORMAT FOR SUBMISSION OF SERUM SAMPLES FOR RFFIT
              </span>
            </div>
            <div style={containerStyle}>
              <div style={{ ...rowStyle, borderTop: "1px solid #000" }}>
                <div style={numberStyle}>1</div>
                <div style={labelStyle}>
                  Owner’s Name, Address & Contact Details (E-mail, Phone No.)
                </div>
                {isEditing ? (
                  <textarea
                    id="owner_mail_phone"
                    className="rffi-pvalue rffiEditable"
                    value={rffiFormData.Owner_Mail_Phone}
                    onChange={(e) =>
                      setRffiFormData({
                        ...rffiFormData,
                        Owner_Mail_Phone: e.target.value,
                      })
                    }
                    style={valueStyle}
                  />
                ) : (
                  <div
                    id="owner_mail_phone"
                    className="rffi-pvalue rffiEditable"
                    style={valueStyle}
                  >
                    {rffiFormData.Owner_Mail_Phone}
                  </div>
                )}
              </div>
              <div style={rowStyle}>
                <div style={numberStyle}>2</div>
                <div style={labelStyle}>Name of the Animal</div>
                {isEditing ? (
                  <textarea
                    id="rffi_mia"
                    className="rffiEditable"
                    value={rffiFormData.RFFI_MIA}
                    onChange={(e) =>
                      setRffiFormData({
                        ...rffiFormData,
                        RFFI_MIA: e.target.value,
                      })
                    }
                    style={valueStyle}
                  />
                ) : (
                  <div
                    id="rffi_mia"
                    className="rffiEditable"
                    style={valueStyle}
                  >
                    {rffiFormData.RFFI_MIA}
                  </div>
                )}
              </div>
              <div style={rowStyle}>
                <div style={numberStyle}>3</div>
                <div style={labelStyle}>Species, Gender</div>
                {isEditing ? (
                  <textarea
                    id="rffi_female"
                    className="rffiEditable"
                    value={rffiFormData.RFFI_Female}
                    onChange={(e) =>
                      setRffiFormData({
                        ...rffiFormData,
                        RFFI_Female: e.target.value,
                      })
                    }
                    style={valueStyle}
                  />
                ) : (
                  <div
                    id="rffi_female"
                    className="rffiEditable"
                    style={valueStyle}
                  >
                    {rffiFormData.RFFI_Female}
                  </div>
                )}
              </div>
              <div style={rowStyle}>
                <div style={numberStyle}>4</div>
                <div style={labelStyle}>Breed</div>
                {isEditing ? (
                  <textarea
                    id="rffi_shih"
                    className="rffiEditable"
                    value={rffiFormData.RFFI_SHIH}
                    onChange={(e) =>
                      setRffiFormData({
                        ...rffiFormData,
                        RFFI_SHIH: e.target.value,
                      })
                    }
                    style={valueStyle}
                  />
                ) : (
                  <div
                    id="rffi_shih"
                    className="rffiEditable"
                    style={valueStyle}
                  >
                    {rffiFormData.RFFI_SHIH}
                  </div>
                )}
              </div>
              <div style={rowStyle}>
                <div style={numberStyle}>5</div>
                <div style={labelStyle}>Age</div>
                {isEditing ? (
                  <textarea
                    id="rffi_years_months"
                    className="rffiEditable"
                    value={rffiFormData.RFFI_Years_Months}
                    onChange={(e) =>
                      setRffiFormData({
                        ...rffiFormData,
                        RFFI_Years_Months: e.target.value,
                      })
                    }
                    style={valueStyle}
                  />
                ) : (
                  <div
                    id="rffi_years_months"
                    className="rffiEditable"
                    style={valueStyle}
                  >
                    {rffiFormData.RFFI_Years_Months}
                  </div>
                )}
              </div>
              <div style={rowStyle}>
                <div style={numberStyle}>6</div>
                <div style={labelStyle}>Date of Birth</div>
                {isEditing ? (
                  <textarea
                    id="rffi_date_time"
                    className="rffiEditable"
                    value={rffiFormData.RFFI_Date_Time}
                    onChange={(e) =>
                      setRffiFormData({
                        ...rffiFormData,
                        RFFI_Date_Time: e.target.value,
                      })
                    }
                    style={valueStyle}
                  />
                ) : (
                  <div
                    id="rffi_date_time"
                    className="rffiEditable"
                    style={valueStyle}
                  >
                    {rffiFormData.RFFI_Date_Time}
                  </div>
                )}
              </div>
              <div style={rowStyle}>
                <div style={numberStyle}>7</div>
                <div style={labelStyle}>Colour</div>
                {isEditing ? (
                  <textarea
                    id="rffi_tri_colour"
                    className="rffiEditable"
                    value={rffiFormData.RFFI_Tri_Colour}
                    onChange={(e) =>
                      setRffiFormData({
                        ...rffiFormData,
                        RFFI_Tri_Colour: e.target.value,
                      })
                    }
                    style={valueStyle}
                  />
                ) : (
                  <div
                    id="rffi_tri_colour"
                    className="rffiEditable"
                    style={valueStyle}
                  >
                    {rffiFormData.RFFI_Tri_Colour}
                  </div>
                )}
              </div>
              <div style={rowStyle}>
                <div style={numberStyle}>8</div>
                <div style={labelStyle}>
                  Microchip No. <br></br>
                  (Only for Pet Travel)
                </div>
                {isEditing ? (
                  <textarea
                    id="rffi_microchip"
                    className="rffiEditable"
                    value={rffiFormData.RFFI_Microchip}
                    onChange={(e) =>
                      setRffiFormData({
                        ...rffiFormData,
                        RFFI_Microchip: e.target.value,
                      })
                    }
                    style={valueStyle}
                  />
                ) : (
                  <div
                    id="rffi_microchip"
                    className="rffiEditable"
                    style={valueStyle}
                  >
                    {rffiFormData.RFFI_Microchip}
                  </div>
                )}
              </div>
              <div style={rowStyle}>
                <div style={numberStyle}>9</div>
                <div style={labelStyle}>Date of Last Vaccination</div>
                {isEditing ? (
                  <textarea
                    id="rffi_vaccination"
                    className="rffiEditable"
                    value={rffiFormData.RFFI_Vaccination}
                    onChange={(e) =>
                      setRffiFormData({
                        ...rffiFormData,
                        RFFI_Vaccination: e.target.value,
                      })
                    }
                    style={valueStyle}
                  />
                ) : (
                  <div
                    id="rffi_vaccination"
                    className="rffiEditable"
                    style={valueStyle}
                  >
                    {rffiFormData.RFFI_Vaccination}
                  </div>
                )}
              </div>
              <div style={rowStyle}>
                <div style={numberStyle}>10</div>
                <div style={labelStyle}>Date of Serum sample collected</div>
                {isEditing ? (
                  <textarea
                    id="rffi_date_collected"
                    className="rffiEditable"
                    value={rffiFormData.RFFI_Date_Collected}
                    onChange={(e) =>
                      setRffiFormData({
                        ...rffiFormData,
                        RFFI_Date_Collected: e.target.value,
                      })
                    }
                    style={valueStyle}
                  />
                ) : (
                  <div
                    id="rffi_date_collected"
                    className="rffiEditable"
                    style={valueStyle}
                  >
                    {rffiFormData.RFFI_Date_Collected}
                  </div>
                )}
              </div>
              <div style={rowStyle}>
                <div style={numberStyle}>11</div>
                <div style={labelStyle}>Date of Serum sample submitted</div>
                {isEditing ? (
                  <textarea
                    id="rffi_date_submitted"
                    className="rffiEditable"
                    value={rffiFormData.RFFI_Date_Submitted}
                    onChange={(e) =>
                      setRffiFormData({
                        ...rffiFormData,
                        RFFI_Date_Submitted: e.target.value,
                      })
                    }
                    style={valueStyle}
                  />
                ) : (
                  <div
                    id="rffi_date_submitted"
                    className="rffiEditable"
                    style={valueStyle}
                  >
                    {rffiFormData.RFFI_Date_Submitted}
                  </div>
                )}
              </div>
              <div className="rffi_Vaccination_Details" style={rowStyle}>
                <div style={numberStyle}>12</div>
                <div style={labelStyle}>
                  Vaccination Details (Scanned copy to be enclosed)
                </div>
                {isEditing ? (
                  <textarea
                    id="rffi_vaccination_enclosed"
                    className="rffiEditable"
                    value={rffiFormData.RFFI_Vaccination_Enclosed}
                    onChange={(e) =>
                      setRffiFormData({
                        ...rffiFormData,
                        RFFI_Vaccination_Enclosed: e.target.value,
                      })
                    }
                    style={valueStyle}
                  />
                ) : (
                  <div
                    id="rffi_vaccination_enclosed"
                    className="rffiEditable"
                    style={valueStyle}
                  >
                    {rffiFormData.RFFI_Vaccination_Enclosed}
                  </div>
                )}
              </div>
              <div className="rffi_Vaccination_Details" style={rowStyle}>
                <div style={numberStyle}>13</div>
                <div style={labelStyle}>
                  Name of the Clinician with KVC No., address and contact
                  details{" "}
                </div>
                {isEditing ? (
                  <textarea
                    id="rffi_name_clinician"
                    className="rffiEditable"
                    value={rffiFormData.RFFI_Name_Clinician}
                    onChange={(e) =>
                      setRffiFormData({
                        ...rffiFormData,
                        RFFI_Name_Clinician: e.target.value,
                      })
                    }
                    style={valueStyle}
                  />
                ) : (
                  <div
                    id="rffi_name_clinician"
                    className="rffiEditable"
                    style={valueStyle}
                  >
                    {rffiFormData.RFFI_Name_Clinician}
                  </div>
                )}
              </div>
            </div>
          </div>
          {/* End Table Stretcher  */}

          <div className="row signature-of-clinician">
            <div className="col-12">
              <span>Signature of clinician</span>
            </div>
          </div>

          <div className="signature-of-clinician1">
            <div className="riff-Note">
              <span className="riff-Note1">
                <strong>Note:</strong>
              </span>
              <ol>
                <li>
                  Serum samples to be collected under aseptic conditions and to
                  be sent under cold conditions.
                </li>
                <li>
                  An amount of Rs. 5000/- per serum sample be paid for titre
                  check intended for International movement
                  <br />
                  of <br /> Pet.
                </li>
                <li>
                  An amount of Rs. 1000/- per serum sample be paid for titre
                  check not intended for International
                  <br /> movement of Pet.
                </li>
              </ol>
            </div>
          </div>

          <p
            className="payment-mode-section"
            style={{
              padding: "18px 0 0 8px",
              fontSize: "15px",
              fontFamily: "Times New Roman",
            }}
          >
            <strong>Payment mode:</strong> In cash or Demand Draft (DD). The DD
            shall be drawn in favour of
            <span style={{ fontWeight: "bold" }}>
              {" "}
              ‘Assistant Comptroller,
            </span>{" "}
            <span style={{ fontWeight: "bold", marginLeft: "107px" }}>
              Veterinary College, Hebbal, Bengaluru’
            </span>
          </p>
          <p
            style={{
              fontSize: "15px",
              textAlign: "center",
              margin: "-11px 0 21px 0",
              fontFamily: "Times New Roman",
            }}
          >
            <strong>Plot no 269 2nd floor udhyog vihar ph</strong>
          </p>
        </div>
      </div>
      <div style={{ display: "flex", flexDirection: "row-reverse" }}>
      <button type="submit" onClick={handleSubmit}>
          Submit
        </button>
        <button onClick={toggleEdit}>{isEditing ? "Save" : "Edit"}</button>
        <button onClick={downloadAsPDF}>Download PDF</button>
      </div>
    </div>
  );
};

const containerStyle = {
  width: "100%",
  // border: '1px solid #000',
  padding: "5px",
  boxSizing: "border-box",
};
const rowStyle = {
  display: "flex",
  borderBottom: "1px solid #000",
  boxSizing: "border-box",
};
const columnStyle = {
  borderRight: "1px solid #000",
  padding: "0px 5px 8px 5px",
  boxSizing: "border-box",
};
const numberStyle = {
  ...columnStyle,
  borderLeft: "1px solid #000",
  width: "5%",
  textAlign: "center",
  fontWeight: "bold",
  fontFamily: "Times New Roman",
};
const labelStyle = {
  ...columnStyle,
  color: "black",
  width: "37%",
  // lineHeight: 1,
  fontWeight: "bold",
  fontFamily: "Times New Roman",
};
const valueStyle = {
  ...columnStyle,
  fontFamily: "Times New Roman",
  width: "65%",
};
const rffFormat1 = {
  padding: "16px 13px 6px 0",
};
const rffFormat2 = {
  textAlign: "center",
  backgroundColor: "revert",
  color: "black",
  fontSize: "19px",
  fontFamily: "Times New Roman",
  fontWeight: "600",
};
const rffFormat3 = {
  fontSize: "18px",
  fontFamily: "Times New Roman",
  fontWeight: "600",
};

export default RffitLaboratoriesForm;
